export default "__VITE_ASSET__UNFsbwip__"